#import "../DepartmentGroupFields.graphql"
query DepartmentGroups($first: Int!, $orderBy: [DepartmentGroupsOrderBy!]) {
  departmentGroups(first: $first, orderBy: $orderBy) {
    nodes {
      ...DepartmentGroupFields
    }
  }
}
